export default "__VITE_PUBLIC_ASSET__6782ec56__"